import React, { useState, useEffect } from "react";
// ICONS
import { MdLocalPrintshop } from "react-icons/md";
import { saveAs } from "file-saver";
import { convertLevelToWord } from "../../../../functions/convertLevelToWord";

import * as XLSX from "xlsx";
const ExcelJS = require("exceljs");

const FilterSchedules = ({ handleFilterData, loadedData }) => {
  // Valeur par défaut : 'level_day_hour'
  const [sortBy, setSortBy] = useState("");

  useEffect(() => {
    handleFilterData(sortSchedules(""));
  }, [sortBy, handleFilterData]);

  const sortSchedules = (sortBy) => {
    const customOrder = [1, 2, 3, 4, 5, 6,61,62, 71, 72, 81, 82,7,8, 9, 10, 11, 12, 13, 14];
    const daysOrder = [
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
      "Dimanche",
    ];
    return loadedData?.slice().sort((a, b) => {
      if (sortBy === "") {
        // Tri par niveau, puis jour, puis horaire de début
        const levelDiff = customOrder.indexOf(parseInt(a.level)) - customOrder.indexOf(parseInt(b.level));
        if (levelDiff !== 0) return levelDiff;
        const dayDiff = daysOrder.indexOf(a.day) - daysOrder.indexOf(b.day);
        if (dayDiff !== 0) return dayDiff;
        // On suppose que startHour est un nombre ou une string comparable
        if (a.startHour < b.startHour) return -1;
        if (a.startHour > b.startHour) return 1;
        return 0;
      }
      // } else if (sortBy === "day") {
       
      //   return daysOrder.indexOf(a.day) - daysOrder.indexOf(b.day);
      // } else if (sortBy === "numberOfPlaces") {
      //   return a.numberOfPlaces - b.numberOfPlaces;
      // } else if (sortBy === "formule") {
      //   return a.formule - b.formule;
      // } else if (sortBy === "level") {
      //   return customOrder.indexOf(parseInt(a.level)) - customOrder.indexOf(parseInt(b.level));

      // }
      return 0;
    });
  };

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();

    // Organiser les données par niveau
    const groupedData = loadedData.reduce((acc, curr) => {
      if (!acc[curr.level]) {
        acc[curr.level] = [];
      }
      acc[curr.level].push(curr);
      return acc;
    }, {});

    // Exemple de style pour l'en-tête
    const headerStyle = {
      font: { bold: true },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF00FF00" }, // Fond vert
      },
    };

    const levelHeaderStyle = {
      font: { bold: true, size: 14 },
      alignment: { horizontal: "center", vertical: "middle" },
    };

    // Exemple de style pour les cellules
    const cellStyle = {
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
    };

    // Parcours de chaque niveau
    Object.keys(groupedData).forEach((level) => {
      const worksheet = workbook.addWorksheet(
        ` ${convertLevelToWord(level)}`
      );
      const dataForLevel = groupedData[level];

      // Ajouter l'en-tête du niveau
      const levelHeaderRow = worksheet.addRow([
        ` ${convertLevelToWord(level)}`,
      ]);
      worksheet.mergeCells(
        `A${levelHeaderRow.number}:C${levelHeaderRow.number}`
      );
      levelHeaderRow.getCell(1).style = levelHeaderStyle;
      levelHeaderRow.height = 30;

      dataForLevel.forEach((schedule) => {
        const { startHour, endHour, day, educator, usersRegisted } = schedule;
        
        // Ajout des en-têtes avec style pour la première ligne
        const headerRow1 = worksheet.addRow([
          "Jour et horaires:",
          `${day} ${startHour}h/${endHour}h`,
        ]);
        worksheet.mergeCells(`B${headerRow1.number}:C${headerRow1.number}`);
        headerRow1.eachCell((cell) => {
          cell.style = headerStyle;
          cell.height = 50; // Hauteur de la ligne
        });

        // Ajout des en-têtes sans style de fond vert pour les autres lignes
        const headerRow2 = worksheet.addRow(["Enseignants:", educator]);
        worksheet.mergeCells(`B${headerRow2.number}:C${headerRow2.number}`);
        headerRow2.eachCell((cell) => {
          cell.style = {
            ...cellStyle,
            font: { bold: true },
          };
          cell.height = 50; // Hauteur de la ligne
        });

        const headerRow3 = worksheet.addRow(["NOM", "Prénom", "Année", 'Tel', 'Email']);
        headerRow3.eachCell((cell, colNumber) => {
          cell.style = {
            ...cellStyle,
            font: { bold: true },
          };
          if (colNumber === 2) {
            worksheet.getColumn(colNumber).width = 15;
          } else if (colNumber === 3) {
            worksheet.getColumn(colNumber).width = 10;
          } else {
            worksheet.getColumn(colNumber).width = 30;
          }
          cell.height = 50; // Hauteur de la ligne
        });

        // Ajout des utilisateurs
        usersRegisted.forEach((user) => {
          const { name, birthDay, phone,email } = user;
          const [lastName, firstName] = name.split(" ");
          const row = worksheet.addRow([
            lastName?.toUpperCase(),
            firstName?.charAt(0)?.toUpperCase() + firstName?.slice(1),
            birthDay?.slice(0, 4),
            phone,
            email
          ]);
          row.eachCell((cell) => {
            cell.style = cellStyle;
            cell.height = 40; // Hauteur de la ligne
          });
        });

        worksheet.addRow([]); // Ajouter une ligne vide après chaque session pour la séparation
        worksheet.addRow([]); // Ajouter une ligne vide après chaque session pour la séparation
      });

      // Ajuster les dimensions des colonnes pour toutes les colonnes de cette feuille
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, "tableau.xlsx");
  };

  return (
    <div className="inputs no-print">
      {/* <select
        style={{ marginTop: "20px", opacity: '0' }}
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
      >
      </select> */}
      <MdLocalPrintshop onClick={handleExport} className="print-button" />
    </div>
  );
};

export default FilterSchedules;
